const getErrorType = (err) => {
  let errorType = 'generic';
  if (/400|500|bad|cancel|error|failed|timeout/gi.test(err.toString())) {
    errorType = 'systemError';
  }

  if (err.message) {
    const { message } = err;
    if (/ineligible/i.test(message)) {
      errorType = 'inEligible';
    } else if (/invaliddata/i.test(message)) {
      errorType = 'invalidData';
    }
  }

  return errorType;
};

export default getErrorType;
